export const getSubrowToggleColumn = () => ({
  id: "subrowToggleColumn",
  header: () => null,
  enableSorting: false,
  enableResizing: false,
  enableColumnFilter: false,
  size: 40,
  cell: ({ row }) => {
    if (!row.getCanExpand()) return null;

    return (
      <div className="px-1 flex items-center justify-center">
        <button
          className="flex items-center justify-center w-6 h-6 rounded-sm hover:bg-gray-100 transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            row.toggleExpanded();
          }}
        >
          <span className="text-gray-500">
            {row.getIsExpanded() ? (
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="currentColor"
              >
                <path d="M8.7 10.7c-.4.4-1 .4-1.4 0l-3-3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 8.6l2.3-2.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-3 3Z"></path>
              </svg>
            ) : (
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="currentColor"
              >
                <path d="M10.7 7.3c.4.4.4 1 0 1.4L7.7 11.7c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4L8.6 8 6.3 5.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l3 3Z"></path>
              </svg>
            )}
          </span>
        </button>
      </div>
    );
  },
});
